import { Play, ArrowRight, Video, BarChart3, Gauge, Sparkles, Lightbulb } from "lucide-react";

export default function ExampleVideos({ onExampleClick }) {
  const examples = [
    {
      url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      title: "Video Musical Viral",
      category: "Entretenimiento"
    },
    {
      url: "https://www.youtube.com/watch?v=jNQXAC9IVRw",
      title: "Tutorial Educativo",
      category: "Educación"
    },
    {
      url: "https://www.youtube.com/watch?v=9bZkp7q19f0",
      title: "Video Motivacional",
      category: "Inspiración"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Prueba con Estos Ejemplos
          </h2>
          <p className="text-lg text-gray-600">
            Haz clic en cualquier ejemplo para ver ViralTubeAI en acción
          </p>
          <a href="/ejemplos" data-testid="see-examples-link" className="vt-btn-primary vt-cta-glow mt-5 rounded-full">
            <Sparkles className="w-4 h-4" /> Ver un análisis real <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        {/* Examples Grid */}
        <div data-testid="example-flow" className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mb-10">
          {[["Video", Video], ["Análisis", BarChart3], ["Score", Gauge], ["Insights", Lightbulb], ["Recomendaciones", Sparkles]].map(([label, Icon], i, arr) => (
            <div key={label} className="flex items-center gap-2 sm:gap-3">
              <span className="inline-flex items-center gap-2 rounded-full border border-purple-200 bg-white px-3 py-1.5 text-xs sm:text-sm font-semibold text-gray-700 shadow-sm">
                <Icon className="w-4 h-4 text-purple-600" /> {label}
              </span>
              {i < arr.length - 1 && <ArrowRight className="w-4 h-4 text-purple-400" />}
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {examples.map((example, index) => (
            <button
              key={index}
              data-testid={`example-video-${index}`}
              onClick={() => onExampleClick && onExampleClick(example.url)}
              className="group w-full min-w-0 bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-left border border-gray-100 hover:border-purple-300"
            >
              <div className="flex items-start gap-4 min-w-0">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <Play className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="inline-block px-3 py-1 bg-purple-100 text-purple-700 text-xs font-semibold rounded-full mb-2">
                    {example.category}
                  </span>
                  <h3 className="font-bold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors">
                    {example.title}
                  </h3>
                  <p className="text-sm text-gray-500 truncate">{example.url}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
